<template>
  <div>
    <create-card route_back="Companies" model_name="empresa" :saving="loading.saving_company">
      <template slot="form">
        <v-form ref="forms0" v-model="forms[0]" lazy-validation>
          <v-stepper v-model="stepper_count" vertical class="ma-5 elevation-0">
            <v-stepper-step :editable="stepper_count > 1" :complete="stepper_count > 1" step="1" >
              Informações básicas
              <small>Nomes e CNPJ</small>
            </v-stepper-step>
            <v-stepper-content :complete="stepper_count > 1" step="1">
              <v-col cols='12'>
                <v-card color="white lighten-1" class="mb-2 pa-3" height="">
                  <CompanyForm ref="forms1" :company="company"></CompanyForm>
                </v-card>
                <div>
                  <v-btn text @click="stepper_count = 1" disabled><v-icon large color="red darken-2">mdi-arrow-up-bold</v-icon></v-btn>
                  <v-btn text @click="nextStepper(2)" ><v-icon large color="green darken-2">mdi-arrow-down-bold</v-icon></v-btn>
                </div>
              </v-col>
            </v-stepper-content>
            
            <v-stepper-step :editable="stepper_count > 2" :complete="stepper_count > 2" step="2">
              Endereço
              <small>Informações sobre o endereço</small>
            </v-stepper-step>
            <v-stepper-content step="2">
              <v-col cols='12'>
                <v-card color="white lighten-1" class="mb-2 pa-3" height="">
                  <AddressForm ref="forms2"   :address="address"></AddressForm>
                </v-card>
                <div>
                  <v-btn text @click="stepper_count = 1"><v-icon class="rodar-upp" large color="red darken-2">mdi-arrow-up-bold</v-icon></v-btn>
                  <v-btn text @click="nextStepper(3)" ><v-icon large color="green darken-2">mdi-arrow-down-bold</v-icon></v-btn>
                </div>
              </v-col>
            </v-stepper-content>

            <v-stepper-step :editable="stepper_count > 3" :complete="stepper_count > 3" step="3">
              Informações bancárias
              <small>Banco, número, agência ...</small>
            </v-stepper-step>
            <v-stepper-content step="3">
              <v-col cols='12'>
                <v-card color="white lighten-1" class="mb-2 pa-3" height="">
                  <BankAccountForm ref="forms3" :account="account"></BankAccountForm>
                </v-card>
                <div>
                  <v-btn text @click="stepper_count = 2"><v-icon class="rodar-upp" large color="red darken-2">mdi-arrow-up-bold</v-icon></v-btn>
                  <v-btn text @click="nextStepper(4)" ><v-icon large color="green darken-2">mdi-arrow-down-bold</v-icon></v-btn>
                </div>
              </v-col>
            </v-stepper-content>

            <v-stepper-step :editable="stepper_count > 4" :complete="stepper_count > 4" step="4">
              Contato
              <small>Telefone, email, comentários</small>
            </v-stepper-step>
            <v-stepper-content step="4">
              <v-col cols='12'>
                <v-card color="white lighten-1" class="mb-2 pa-3" height="">
                  <ContactForm ref="forms4" :contact="contact"></ContactForm>
                </v-card>
                <div>
                  <v-btn text @click="stepper_count = 3"><v-icon class="rodar-upp" large color="red darken-2">mdi-arrow-up-bold</v-icon></v-btn>
                  <v-btn text @click="nextStepper(5)" ><v-icon large color="green darken-2">mdi-arrow-down-bold</v-icon></v-btn>
                </div>
              </v-col>
            </v-stepper-content>

            <v-stepper-step  step="5"> Créditos e limites </v-stepper-step>
            <v-stepper-content step="5" :complete="stepper_count > 5">
              <v-col cols='12'>
                <v-card color="white lighten-1" class="mb-2 pa-3" height="">
                  <CompanyCreditForm ref="forms5" :company_credit="company_credit"></CompanyCreditForm>
                </v-card>
                <div>
                  <v-btn text @click="stepper_count = 3"><v-icon class="rodar-upp" large color="red darken-2">mdi-arrow-up-bold</v-icon></v-btn>
                  <f-btn save @click="postCompany"></f-btn>
                </div>
              </v-col>
            </v-stepper-content>

          </v-stepper>
        </v-form>
      </template>
    </create-card>
  </div>
</template>

<script>
import Api from '@/api/index';
import validations from '@/mixins/validations.js'

export default {
  name: "CreateCompany",
  components: {
    CompanyForm: ()=> import("./forms/CompanyForm.vue"),
    BankAccountForm: ()=> import("@/_backoffice/_registrations/components/shared/forms/BankAccountForm.vue"),
    ContactForm: ()=> import("@/_backoffice/_registrations/components/shared/forms/ContactForm.vue"),
    CompanyCreditForm: ()=> import("./forms/CompanyCreditForm.vue"),
    AddressForm: ()=> import("@/_backoffice/_registrations/components/shared/forms/AddressForm.vue"),
    CreateCard: ()=> import("@/_backoffice/_registrations/components/shared/create/CreateCard.vue"),

  },
  mixins:[validations],
  data() {
    return {
      loading: {saving_company: false},
      dialog: true,
      stepper_count: 1,
      company: {},
      address: {},
      account: {
        current_account: true
      },
      contact: {},
      vrt_account: {},
      company_credit: {},
      forms: [false, false, false, false, false, false],
    }
  },
  methods: {
    getData(){
    },
    prepareCompany(){ 
      return {
        ...this.company,
        status_id: 1,
        addresses_attributes: [{ ...this.address}],
        contacts_attributes: [{...this.contact}],
        account_attributes: {...this.account},
        vrt_accounts_attributes: {...this.vrt_account},
        own_client_attributes: {
          client_credit_attributes: {...this.company_credit, 
            limit: parseFloat(this.company_credit.limit.replace(/,/g, ''))
          }
        }
      }
    },
    postCompany(){
      if(this.validateForm(5)){
        this.swallConfirmation({
          title: `Deseja cadastrar empresa?`,
          icon: 'question',
        }).then( confirmed =>{
          if (confirmed ) {
            let company = this.prepareCompany()
            this.loading.saving_company = true
            Api.Company.create(company).then(r => {
              this.resetFields()
              this.addNotification({type: 'success', msg: 'Criado com sucesso!'})
            }).catch(err => {
              this.addNotification({type: 'error', msg: err?.response?.data?.errors ? `${err.response.data.errors}` : "Erro ao criar"})
            }).finally(()=>{
              this.loading.saving_company = false
            })
          }
        })
      }
    },
    resetFields(){
      this.company = {},
      this.address = {},
      this.account = {current_account: true},
      this.contact = {},
      this.company_credit = {},
      this.stepper_count = 1
      for(let i = 1 ; i <= 5 ; i++ ){
        this.$refs[`forms${i}`].$refs.form.resetValidation()
      }
    },
    nextStepper(number){
      if (this.validateForm(number-1)){
        this.stepper_count = number
      }
    },
    validateForm(number){
      this.forms[number] =  this.$refs[`forms${number}`].validate()
      return this.forms[number]
    },
  },
  mounted() {
    this.getData();
  },
}
</script>